import type { ChannelType } from '@buffer-mono/popcorn'

import { isChannelType } from '~publish/helpers/channels'

export function isChannelIconService(service: string): service is ChannelType {
  return isChannelType(service)
}
